/**
 * @module:  卡片Skeleton
 * @author Liang Huang
 * @date 2020-11-10 14:35:29
 */
import React, { Fragment } from 'react';
import ContentLoader from 'react-content-loader';
import './style'; // interface IProps {
//   headimage?: 'left' | 'right';
//   rows?: number;
//   height?: number;
// }
// const HeadCard = (props) => {
//   return null;
// };

var clientWidth = document.body.clientWidth;
var paddingLeft = 16;
var paddingTop = 16;
var lineWhite = 6;
var rowBottom = 8;
var titleHeight = 16;
var lineHeight = 12;
var headimageWidth = 48;
/**
 * 无法使用map等jsx 语法
 * @param props
 */

var SkeletonCard = function SkeletonCard(props) {
  var headimage = props.headimage,
      height = props.height;
  var headLeft = 0;

  if (headimage === 'left') {
    headLeft = headimageWidth + 8;
  }

  var rectX = paddingLeft + headLeft; // const titleWidth = 120 - rectX;

  var rectWidth = clientWidth - paddingLeft * 2 - headLeft;
  var lastWidth = clientWidth - paddingLeft * 4 - headLeft;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "SkeletonCard"
    },
    /*#__PURE__*/
    React.createElement(ContentLoader, {
      speed: 2,
      width: 375,
      height: height || 130,
      backgroundColor: "#eee",
      foregroundColor: "#ecebeb"
    }, headimage &&
    /*#__PURE__*/
    // <HeadCard {...props} />
    React.createElement("circle", {
      r: 24,
      cx: paddingLeft + 20,
      cy: paddingTop + 24
    }),
    /*#__PURE__*/
    React.createElement(Fragment, null,
    /*#__PURE__*/
    React.createElement("rect", {
      x: rectX,
      y: paddingTop,
      rx: "3",
      ry: "3",
      width: 120,
      height: titleHeight
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: rectX,
      y: rowBottom + titleHeight + paddingTop + lineWhite,
      rx: "3",
      ry: "3",
      width: rectWidth,
      height: lineHeight
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: rectX,
      y: 2 * (rowBottom + titleHeight) + paddingTop + lineWhite,
      rx: "3",
      ry: "3",
      width: rectWidth,
      height: lineHeight
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      x: rectX,
      y: 3 * (rowBottom + titleHeight) + paddingTop + lineWhite,
      rx: "3",
      ry: "3",
      width: lastWidth,
      height: lineHeight
    }))))
  );
};

export default SkeletonCard;